<template>
  <b-container fluid>
    <div class="row justify-content-md-center">
      <div class="col-lg-9">
        <template>
          <div
            class="accordion"
            role="tablist"
            v-if="gettFaqAllActive.length > 0"
          >
            <div v-for="(item, index3) in gettFaqAllActive" :key="index3">
              <template>
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button
                      block
                      href="#"
                      v-b-toggle="'accordion-' + index3"
                      variant="secondary"
                      class="text-left fs-1300 fw-600 pb-3 pt-3"
                    >
                      {{ item.title }}
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    :id="'accordion-' + index3"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <p class="mb-0 fs-1100" v-html="item.description"></p>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FAQ',
  mounted() {
    findash.index()
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['gettFaqAllActive'])
  },
  methods: {
    ...mapActions(['fetchFaqAllActive'])
  },
  created() {
    this.fetchFaqAllActive()
  }
}
</script>
